import {createApp} from 'vue'
import { createVfm } from 'vue-final-modal'
import App from './App.vue'
import {createRouter, createWebHistory} from 'vue-router'
import 'vue-final-modal/style.css'
import 'reset.css/reset.css'
import './assets/css/main.css'
import RggSeason from "@/views/RggSeason";
import RggLogin from "@/views/RggLogin";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import IconService from "./services/icon-service"
import moment from "moment"

IconService.init()

const routes = [
    {name: "Home", path: "/", redirect: "/season/2"},
    {name: "Login", path: "/login", component: RggLogin},
    {name: "Season", path: "/season/:seasonNumber", component: RggSeason, props: true},
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

moment.locale('ru')
const app = createApp(App)
const vfm = createVfm()
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(vfm)
app.use(router)
app.mount('#app')

Number.prototype.pad = function(size) {
    let s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
}